import styled from "styled-components";

export const StyledStepBarContainer = styled.div`
    max-width: var(--max-page-width);
    padding-bottom: 15px;
    align-self: center;
    width: 100%;
`;

export const StyledOuterContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const StyledContainer = styled.div<{ $condensed: boolean }>`
    max-width: ${(props) => (props.$condensed ? "620px;" : "var(--max-page-width)")};
    margin: 0 auto;
`;
